import * as React from 'react';
import Pagination from 'ted-ui/build/Pagination';
import Spacing from '@able/react/dist/Spacing';
import Grid from '@able/react/dist/Grid';
import SectionHeader from '@able/react/dist/SectionHeader';
import Surface from '@able/react/dist/Surface';
import { generateElementId, getOrderDetailsRoutePath } from '@applications/order-tracker/utils';
import { OrderDetailsSections, ProductsTableConfig } from '../../../../config/order-tracker-new-common/constants';
import ProductsTable from './components/products-table';
import UseTablePagination from '../../hooks/use-table-pagination';
import ProductSheet from '../../../product-sheet';
import useProductSheetNavigation from '../../../product-sheet/hooks/use-product-sheet-navigation';
import '../../../order-details-new/style.less'
import { IOrderTrackerAppState } from '@telstra-connect/order-tracker/state';
import { useSelector } from 'react-redux';
import { customizeTableCell } from '../../../../config/order-tracker-new-common/customize-table-cell';
import { useParams } from 'react-router-dom';
import { IOrderDetailsStateResponse } from '@telstra-connect/order-tracker/state/order-details';

const iconDevelopmentURL = require('../../../../../../images/able-sprites.svg');

const ProductsOrdered = () => {
  const data: IOrderDetailsStateResponse = useSelector(
    (state: IOrderTrackerAppState) => state.orderTracker.orderDetailsNew?.data
  );
  const productsTableData = data.orderSummary.products;
  const productsTableColumns = data.columns;
  const { orderNumber, cidn, productNumber, tab } = useParams();
  const parentPageRoute = getOrderDetailsRoutePath(cidn, orderNumber, true);

  const { currentProduct, closeProductSheet } =
    useProductSheetNavigation({ parentPageRoute, productNumber, tab, productsTableData });

  const { currentPageData, currentPage, handlePageChange } = UseTablePagination(
    { data: productsTableData, itemsPerPage: ProductsTableConfig.PageSize }
  );

  return (
    <div
      id={generateElementId(OrderDetailsSections.ProductsOrdered)}
      data-testid={generateElementId(OrderDetailsSections.ProductsOrdered)}
    >
      <Surface
        background="materialBasePrimary"
        cornerRadius="cornerRadiusNone"
        interactive={false}
        variant="SurfaceFlat"
      >
        <Spacing top="spacing7x" bottom="spacing7x">
          <Grid>
            <SectionHeader
              title={OrderDetailsSections.ProductsOrdered}
              headingElement="h2"
              variantLevel="Level1"
              subtitle=""
              actionLabel=""
            />
            {productsTableData && (
              <React.Fragment>
                <ProductsTable
                  productsTableColumns={customizeTableCell(
                    productsTableColumns,
                    false
                  )}
                  productsTableData={currentPageData}
                />
                <Spacing top="spacing4x">
                  <div className="custom-ted-ui-pagination-alignment">
                    <Pagination
                      page={currentPage}
                      totalRecords={productsTableData.length}
                      pageSize={ProductsTableConfig.PageSize}
                      developmentUrl={iconDevelopmentURL}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </Spacing>
                {currentProduct && (
                  <ProductSheet
                    open={!!productNumber}
                    product={currentProduct}
                    parentPageRoute={parentPageRoute}
                    goBackEvent={closeProductSheet}
                  />
                )}
              </React.Fragment>
            )}
          </Grid>
        </Spacing>
      </Surface>
    </div>
  );
};

export default ProductsOrdered;
